import InfoField from '../InfoField';
import { formatFechaHora, formatUsuarioDisplay } from '../../utils';

const SinAlternativaDetallePanel = ({ sinAlternativa }) => {
    if (!sinAlternativa?.motivo) {
        return null;
    }

    return (
        <div className="row g-3">
            <div className="col-md-12">
                <InfoField label="Motivo" value={sinAlternativa.motivo} />
            </div>
            {sinAlternativa.usuario ? (
                <div className="col-md-6">
                    <InfoField
                        label="Recambista"
                        value={formatUsuarioDisplay(sinAlternativa.usuario)}
                    />
                </div>
            ) : null}
            {sinAlternativa.fecha_hora ? (
                <div className="col-md-6">
                    <InfoField
                        label="Fecha"
                        value={formatFechaHora(sinAlternativa.fecha_hora)}
                    />
                </div>
            ) : null}
        </div>
    );
};

export default SinAlternativaDetallePanel;
